module.exports = __webpack_public_path__ + "static/media/noImgBig.7a16386e.png";